import { useEffect, useRef, useState } from "react";
import { paymentError, usePaymentScope } from "./payment-ui";

export function usePaymentDocuments(accountId?: string) {
  const scope = usePaymentScope(accountId);
  const urls = useRef(new Set<string>());
  const windows = useRef(new Set<Window>());
  const timers = useRef(new Set<number>());
  const [error, setError] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);
  const pending = useRef(false);
  useEffect(
    () => () => {
      timers.current.forEach(window.clearInterval);
      windows.current.forEach((popup) => popup.close());
      urls.current.forEach(URL.revokeObjectURL);
      urls.current.clear();
    },
    [scope.identity],
  );
  function download(blob: Blob, filename: string) {
    const url = URL.createObjectURL(blob);
    urls.current.add(url);
    const a = document.createElement("a");
    a.href = url;
    a.download = filename.replace(/[^a-zA-Z0-9._-]/g, "_");
    document.body.append(a);
    a.click();
    a.remove();
    const timer = window.setTimeout(() => {
      URL.revokeObjectURL(url);
      urls.current.delete(url);
      timers.current.delete(timer);
    }, 60_000);
    timers.current.add(timer);
  }
  async function fetchDocument(
    load: () => Promise<Blob>,
    filename: string,
    open = false,
  ): Promise<boolean> {
    if (pending.current) return false;
    const guard = scope.capture();
    const popup = open ? window.open("about:blank", "_blank") : null;
    if (popup) {
      popup.opener = null;
      windows.current.add(popup);
    }
    pending.current = true;
    setBusy(true);
    setError(null);
    try {
      const blob = await load();
      if (!guard.isCurrent()) {
        popup?.close();
        return false;
      }
      if (popup && !popup.closed) {
        const url = URL.createObjectURL(blob);
        urls.current.add(url);
        popup.location.href = url;
        const timer = window.setInterval(() => {
          if (popup.closed) {
            URL.revokeObjectURL(url);
            urls.current.delete(url);
            windows.current.delete(popup);
            window.clearInterval(timer);
            timers.current.delete(timer);
          }
        }, 1000);
        timers.current.add(timer);
      } else {
        download(blob, filename);
        if (open) setError("Окно заблокировано. PDF передан для скачивания.");
      }
      return true;
    } catch (caught) {
      popup?.close();
      if (guard.isCurrent()) setError(paymentError(caught));
      return false;
    } finally {
      if (guard.isCurrent()) {
        pending.current = false;
        setBusy(false);
      }
    }
  }
  return { fetchDocument, error, busy };
}
